import AxiosInstance from 'config/apiServiceApiGateway'

export type RefundStatusEnum = 'PENDING' | 'APPROVED' | 'REJECTED'

export type RefundSortByEnum = 'created_at' | 'status' | 'completed_at'

export type RefundOrderDirectionEnum = 'ASCENDING' | 'DESCENDING' | 'ORDER_DIRECTION_UNSPECIFIED'

export type CustomBillingApiType = {
  id: number
  npwp: string
  address: string
  name: string
  seller_type: string
  bank_account_number: string
  bank_name: string
  bank_account_name: string
}

export type RefundSubmissionApiType = {
  id: string | number
  approval_id: string | number
  invoice_id: string
  seller_name: string
  created_at: string
  completed_at: string | null
  amount: string | number
  refund_total_amount: string | number
  bank_name: string
  bank_account_number: string
  bank_account_name: string
  status: RefundStatusEnum
  rejection_note: string
  event_ref_id: string
  event_ref_type: string
  seller_id: string | number
  requester_id: string | number
  npwp?: string
  custom_billing?: CustomBillingApiType | null
  requester_name: string
  requester_role?: string
  requester_email?: string
  current_attempt_number: number
  refund_fee_amount: string | number
  refund_amount: string | number
  tax_slip: string
  reviewer_id: string
  reviewer_role?: string
  reviewer_name?: string
  client_timestamp: string
  created_by: string
  updated_at: string | null
  updated_by: string
  deleted_at: string | null
  deleted_by: string
}

export type RefundListParamsType = {
  statuses?: RefundStatusEnum
  start_date?: string
  end_date?: string
  page_size?: number
  page_cursor?: string
  seller_ids?: string
  sort_by?: RefundSortByEnum
  order_direction?: RefundOrderDirectionEnum
}

export type RefundPaginationType = {
  next_cursor: string | null
  prev_cursor: string | null
}

export type RefundListResponseType = {
  data: {
    refund_submissions: RefundSubmissionApiType[]
  }
  pagination: RefundPaginationType
}

export type RefundExportResponseType = {
  file_url: string
}

export const getRefundSubmissions = (params: RefundListParamsType) =>
  AxiosInstance.Get<RefundListResponseType, true>({
    url: '/ads/internal/v1/creditmanager/refund/submissions',
    params: {
      ...params,
      sort_by: params.sort_by ?? 'created_at',
      order_direction: params.order_direction ?? 'DESCENDING',
    },
  })

export const exportRefundSubmissions = (
  params: Omit<RefundListParamsType, 'page_cursor' | 'page_size'>,
) =>
  AxiosInstance.Get<RefundExportResponseType, true>({
    url: '/ads/internal/v1/creditmanager/refund/submissions/export',
    params: {
      ...params,
      sort_by: params.sort_by ?? 'created_at',
      order_direction: params.order_direction ?? 'DESCENDING',
    },
  })
